(function () {
  'use strict';

  var STORAGE_KEY = 'polly_shipping_zip';
  var RECIFE_MIN = 50000000;
  var RECIFE_MAX = 52999999;
  var JABOATAO_MIN = 54000000;
  var JABOATAO_MAX = 54499999;
  var ensureTimer = null;

  function digits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(value) {
    var zip = digits(value);
    return zip.length > 5 ? zip.slice(0, 5) + '-' + zip.slice(5) : zip;
  }

  function inRange(zip, min, max) {
    var number = Number(zip);
    return number >= min && number <= max;
  }

  function isRecife(zip) {
    return inRange(zip, RECIFE_MIN, RECIFE_MAX);
  }

  function isUberArea(zip) {
    return isRecife(zip) || inRange(zip, JABOATAO_MIN, JABOATAO_MAX);
  }

  function normalized(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(value) {
    var amount = Number(String(value == null ? 0 : value).replace(',', '.'));
    if (!isFinite(amount)) return escapeHtml(value);
    if (amount === 0) return 'Grátis';
    return amount.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function addStyles() {
    if (document.getElementById('polly-cart-shipping-style')) return;

    var style = document.createElement('style');
    style.id = 'polly-cart-shipping-style';
    style.textContent = [
      '#cartDrawer .polly-cart-shipping{display:block!important;visibility:visible!important;opacity:1!important;margin:12px 12px 14px;padding:12px;border:1px solid rgba(0,0,0,.10);border-radius:8px;background:#fff;position:relative;z-index:2}',
      '#cartDrawer .polly-cart-shipping__title{font-size:13px;font-weight:700;margin:0 0 8px;color:inherit}',
      '#cartDrawer .polly-cart-shipping__row{display:flex;gap:8px;align-items:stretch;width:100%}',
      '#cartDrawer .polly-cart-shipping__input{min-width:0;flex:1;height:42px;border:1px solid rgba(0,0,0,.20);border-radius:6px;padding:0 11px;font-size:13px;background:#fff;color:#222;outline:none}',
      '#cartDrawer .polly-cart-shipping__input:focus{border-color:#AC7E3A;box-shadow:0 0 0 1px #AC7E3A}',
      '#cartDrawer .polly-cart-shipping__button{height:42px;border:0;border-radius:6px;padding:0 13px;background:#AC7E3A;color:#fff;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap}',
      '#cartDrawer .polly-cart-shipping__button[disabled]{opacity:.6;cursor:wait}',
      '#cartDrawer .polly-cart-shipping__response{margin-top:9px;font-size:12px}',
      '#cartDrawer .polly-cart-shipping__status{margin:0;line-height:1.4;color:rgba(0,0,0,.66)}',
      '#cartDrawer .polly-cart-shipping__error{color:#9b2c2c}',
      '#cartDrawer .polly-cart-shipping__rates{display:grid;gap:6px;margin-top:8px}',
      '#cartDrawer .polly-cart-shipping__rate{display:flex;justify-content:space-between;align-items:flex-start;gap:10px;padding:8px 9px;border:1px solid rgba(0,0,0,.10);border-radius:5px}',
      '#cartDrawer .polly-cart-shipping__rate-main{min-width:0}',
      '#cartDrawer .polly-cart-shipping__rate-name{font-weight:700;line-height:1.25}',
      '#cartDrawer .polly-cart-shipping__rate-note{display:block;margin-top:2px;font-size:10.5px;line-height:1.3;color:rgba(0,0,0,.58)}',
      '#cartDrawer .polly-cart-shipping__rate-price{font-weight:700;white-space:nowrap}',
      '#cartDrawer .polly-cart-shipping__footnote{display:block;margin-top:7px;font-size:10px;line-height:1.35;color:rgba(0,0,0,.52)}',
      '@media(max-width:480px){#cartDrawer .polly-cart-shipping__row{gap:6px}#cartDrawer .polly-cart-shipping__button{padding:0 10px;font-size:11px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function markup() {
    return '<div class="polly-cart-shipping" data-polly-cart-shipping>' +
      '<p class="polly-cart-shipping__title">Calcule o frete</p>' +
      '<div class="polly-cart-shipping__row">' +
        '<input class="polly-cart-shipping__input" type="tel" inputmode="numeric" autocomplete="off" autocorrect="off" spellcheck="false" data-lpignore="true" data-form-type="other" maxlength="9" placeholder="Digite seu CEP" aria-label="CEP para cálculo do frete" data-polly-shipping-zip>' +
        '<button class="polly-cart-shipping__button" type="button" data-polly-shipping-button>CALCULAR</button>' +
      '</div>' +
      '<div class="polly-cart-shipping__response" aria-live="polite" data-polly-shipping-response></div>' +
    '</div>';
  }

  function restoreZip(root) {
    var input = root && root.querySelector('[data-polly-shipping-zip]');
    if (!input) return;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  function hideLegacyCalculator(drawer) {
    var legacy = drawer.querySelector('#cart-shipping-rates');
    if (!legacy) return;

    var legacyWrapper = legacy.closest('.collapsible-tab');
    if (legacyWrapper) legacyWrapper.style.display = 'none';
  }

  function ensureCalculator() {
    addStyles();

    document.querySelectorAll('#cartDrawer').forEach(function (drawer) {
      hideLegacyCalculator(drawer);

      var existing = drawer.querySelector('[data-polly-cart-shipping]');
      if (existing) {
        restoreZip(existing);
        return;
      }

      var target = drawer.querySelector('.cart-drawer__content');
      if (!target) target = drawer.querySelector('.cart-drawer__footer');
      if (!target) return;

      var holder = document.createElement('div');
      holder.innerHTML = markup();
      var calculator = holder.firstElementChild;

      target.appendChild(calculator);
      restoreZip(calculator);
    });
  }

  function queueEnsure() {
    clearTimeout(ensureTimer);
    ensureTimer = setTimeout(ensureCalculator, 40);
  }

  async function provinceFor(zip) {
    try {
      var response = await fetch(
        'https://brasilapi.com.br/api/cep/v1/' + encodeURIComponent(zip),
        { cache: 'no-store' }
      );
      if (!response.ok) return '';
      var data = await response.json();
      return data && data.state ? String(data.state) : '';
    } catch (error) {
      return '';
    }
  }

  function rateQuery(zip, province) {
    var params = new URLSearchParams();
    params.set('shipping_address[zip]', zip);
    params.set('shipping_address[country]', 'Brazil');
    if (province) params.set('shipping_address[province]', province);
    return params.toString();
  }

  async function fetchRates(zip, province) {
    var response = await fetch('/cart/shipping_rates.json?' + rateQuery(zip, province), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      var message = 'Não foi possível calcular o frete agora.';
      try {
        var errorData = await response.json();
        if (errorData && errorData.zip) {
          message = Array.isArray(errorData.zip)
            ? errorData.zip.join(', ')
            : String(errorData.zip);
        } else if (errorData && errorData.error) {
          message = String(errorData.error);
        }
      } catch (error) {}
      throw new Error(message);
    }

    var data = await response.json();
    return Array.isArray(data.shipping_rates) ? data.shipping_rates : [];
  }

  function localExtras(zip, rates) {
    var names = rates.map(function (rate) {
      return normalized(rate.name);
    });

    var extras = [];
    var hasPickup = names.some(function (name) {
      return name.indexOf('retirada') !== -1 || name.indexOf('pickup') !== -1;
    });
    var hasUber = names.some(function (name) {
      return name.indexOf('uber') !== -1;
    });

    if (isRecife(zip) && !hasPickup) {
      extras.push({
        name: 'Retirada em Recife',
        customPrice: 'Grátis',
        customNote: 'Retirada disponível para CEPs de Recife.'
      });
    }

    if (isUberArea(zip) && !hasUber) {
      extras.push({
        name: 'Uber Flash',
        customPrice: 'A combinar',
        customNote: 'Entre em contato para combinar o valor e a entrega.'
      });
    }

    return extras;
  }

  function noteFor(rate) {
    if (rate.customNote) return rate.customNote;
    if (rate.delivery_date) return 'Entrega estimada: ' + rate.delivery_date;

    if (rate.delivery_range) {
      var min = rate.delivery_range.minimum;
      var max = rate.delivery_range.maximum;
      if (min != null && max != null) {
        return min === max
          ? 'Prazo estimado: ' + min
          : 'Prazo estimado: ' + min + ' a ' + max;
      }
    }

    return '';
  }

  function rateHtml(rate) {
    var note = noteFor(rate);
    return '<div class="polly-cart-shipping__rate">' +
      '<div class="polly-cart-shipping__rate-main">' +
        '<div class="polly-cart-shipping__rate-name">' +
          escapeHtml(rate.name || 'Entrega') +
        '</div>' +
        (note
          ? '<span class="polly-cart-shipping__rate-note">' + escapeHtml(note) + '</span>'
          : '') +
      '</div>' +
      '<div class="polly-cart-shipping__rate-price">' +
        escapeHtml(rate.customPrice || money(rate.price)) +
      '</div>' +
    '</div>';
  }

  function showRates(responseElement, zip, rates) {
    var allRates = rates.concat(localExtras(zip, rates));

    if (!allRates.length) {
      responseElement.innerHTML =
        '<p class="polly-cart-shipping__status polly-cart-shipping__error">' +
        'Nenhuma opção de entrega foi encontrada para este CEP.' +
        '</p>';
      return;
    }

    responseElement.innerHTML =
      '<p class="polly-cart-shipping__status">Opções para ' +
      escapeHtml(formatCep(zip)) +
      ':</p>' +
      '<div class="polly-cart-shipping__rates">' +
      allRates.map(rateHtml).join('') +
      '</div>' +
      '<small class="polly-cart-shipping__footnote">' +
      'Cotação para os itens atuais do carrinho. O checkout confirma a disponibilidade e o valor final.' +
      '</small>';
  }

  async function calculate(root) {
    var input = root.querySelector('[data-polly-shipping-zip]');
    var button = root.querySelector('[data-polly-shipping-button]');
    var responseElement = root.querySelector('[data-polly-shipping-response]');
    var zip = digits(input && input.value);

    if (zip.length !== 8) {
      responseElement.innerHTML =
        '<p class="polly-cart-shipping__status polly-cart-shipping__error">' +
        'Digite um CEP válido com 8 números.' +
        '</p>';
      if (input) input.focus();
      return;
    }

    try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}

    if (input) input.value = formatCep(zip);
    if (button) {
      button.disabled = true;
      button.textContent = 'CALCULANDO...';
    }

    responseElement.innerHTML =
      '<p class="polly-cart-shipping__status">Buscando opções de entrega...</p>';

    try {
      var province = await provinceFor(zip);
      var rates = await fetchRates(zip, province);
      showRates(responseElement, zip, rates);
    } catch (error) {
      var extras = localExtras(zip, []);

      if (extras.length) {
        responseElement.innerHTML =
          '<p class="polly-cart-shipping__status">' +
          'A cotação das transportadoras não carregou agora. Opções locais:' +
          '</p>' +
          '<div class="polly-cart-shipping__rates">' +
          extras.map(rateHtml).join('') +
          '</div>';
      } else {
        responseElement.innerHTML =
          '<p class="polly-cart-shipping__status polly-cart-shipping__error">' +
          escapeHtml(
            error && error.message
              ? error.message
              : 'Não foi possível calcular o frete agora.'
          ) +
          '</p>';
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = 'CALCULAR';
      }
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-polly-shipping-button]');
    if (!button) return;

    var root = button.closest('[data-polly-cart-shipping]');
    if (root) calculate(root);
  });

  document.addEventListener('keydown', function (event) {
    var input = event.target.closest && event.target.closest('[data-polly-shipping-zip]');
    if (!input || event.key !== 'Enter') return;

    event.preventDefault();
    var root = input.closest('[data-polly-cart-shipping]');
    if (root) calculate(root);
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-polly-shipping-zip]');
    if (!input) return;
    input.value = formatCep(input.value);
  });

  ensureCalculator();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureCalculator);
  }

  new MutationObserver(queueEnsure).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();